module.exports = __webpack_public_path__ + "img/baseline-redo-24px.d2107f44.svg";